export default class ChannelLocale {
  public code: String;

  constructor(code: String) {
    this.code = code;
  }
}
